import './AuthenticationLayout.css'

import { Link, Outlet } from 'react-router'

import { BrandLogo } from '../components/BrandLogo'
import { ScrollArea } from '../components/ScrollArea'

const blogUrl = 'https://blog.revel.club'
/** External/auth chrome → marketing site (localhost landing in dev). */
const landingUrl =
  import.meta.env['VITE_LANDING_URL'] ||
  (import.meta.env.DEV ? 'http://localhost:3051' : 'https://revel.club')

export function AuthenticationLayout() {
  return (
    <div className="authentication-layout">
      <aside className="authentication-layout__sidebar">
        <div className="authentication-layout__branding">
          <BrandLogo href={landingUrl} layout="full" size="lg" onChrome />
          <div className="authentication-layout__tagline">
            <h1 className="authentication-layout__tagline-text display-title">
              Curated matches.
              <br />
              Genuine intentions.
            </h1>
            <p className="authentication-layout__tagline-subtext">
              An exclusive community for people ready to find something meaningful.
            </p>
          </div>
        </div>
        <p className="authentication-layout__footer">
          &copy; {new Date().getFullYear()} Revel Club. All rights reserved.
        </p>
      </aside>

      <ScrollArea vertical fitParent className="authentication-layout__main">
        <div className="authentication-layout__main-content">
          <div className="authentication-layout__mobile-header">
            <BrandLogo href={landingUrl} layout="full" size="sm" />
          </div>
          <div className="authentication-layout__content">
            <Outlet />
          </div>
          <footer className="authentication-layout__legal">
            <a href={blogUrl} className="authentication-layout__legal-link">
              Blog
            </a>
            <Link to="/terms" className="authentication-layout__legal-link">
              Terms
            </Link>
            <Link to="/privacy" className="authentication-layout__legal-link">
              Privacy
            </Link>
          </footer>
        </div>
      </ScrollArea>
    </div>
  )
}
